import React from 'react'
import classNames from 'classnames'
import classes from './four-oh-four.module.css'
import gridClasses from '../../styles/grid.module.css'
import { Button } from '../../components/Button/Button'
import { useHistory, useLocation } from 'react-router'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import { Header } from '../../components/Header/Header'
import { Hero, HeroTitle, HeroContent } from '../../components/Hero/Hero'

function Error404() {
    const { goBack } = useHistory()

    const location = useLocation()

    const finalDestination = location.state?.finalDestination || false

    return (
        <div className={classNames(classes.pageContent, gridClasses.container)}>
            <h1 className={classes.title}>404. Not Found.</h1>
            <p className={classes.subtitle}>
                Seems like you're trying to go outside our defined reality. The
                laws of physics disallow that.
            </p>
            {!finalDestination && (
                <Button className={classes.action} onClick={goBack}>
                    Go Back
                </Button>
            )}
        </div>
    )
}

export function AppError404() {
    return (
        <div className={classes.container}>
            <AuthenticatedHeader />
            <Error404 />
        </div>
    )
}

export function WebsiteError404() {
    return (
        <div className={classes.container}>
            <Hero header={<Header />}>
                <HeroContent centered>
                    <HeroTitle centered>An error occured.</HeroTitle>
                </HeroContent>
            </Hero>
            <Error404 />
        </div>
    )
}
